'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nodeForge = require('node-forge');

var _curve = require('../keys/curve25519');

var _rsa = require('../keys/rsa');

var _publicKey = require('./publicKey');

var _publicKey2 = _interopRequireDefault(_publicKey);

var _constants = require('./constants');

var _encoding = require('../utils/encoding');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SigningPrivateKey = function SigningPrivateKey(_ref) {
  var algo = _ref.algo,
      pemPrivateKey = _ref.pemPrivateKey,
      password = _ref.password;

  _classCallCheck(this, SigningPrivateKey);

  _initialiseProps.call(this);

  if (pemPrivateKey) {
    this.load(pemPrivateKey, password);
  } else {
    this.generate(algo);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.generate = function (algo) {
    _this._algo = algo;
    switch (algo) {
      case _constants.SIGNING_ALGO_RSA.name:
        {
          _this._key = new _rsa.RSAPrivateKey();
          break;
        }
      case _constants.SIGNING_ALGO_ED25519.name:
        {
          _this._key = new _curve.ED25519PrivateKey();
          break;
        }
      default:
        throw new Error('Unsupported signing algorithm "' + algo + '"');
    }
  };

  this.load = function (pemPrivateKey) {
    var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _decodePrivateKey = (0, _encoding.decodePrivateKey)(pemPrivateKey, password),
        key = _decodePrivateKey.key,
        oid = _decodePrivateKey.oid;

    switch (oid) {
      case _constants.SIGNING_ALGO_RSA.oid:
        _this._key = new _rsa.RSAPrivateKey(_nodeForge.pki.privateKeyFromAsn1(key));
        _this._algo = _constants.SIGNING_ALGO_RSA.name;
        break;
      case _constants.SIGNING_ALGO_ED25519.oid:
        _this._key = (0, _curve.ed25519PrivateKeyFromAsn1)(key);
        _this._algo = _constants.SIGNING_ALGO_ED25519.name;
        break;
      default:
        throw new Error('Unsupported signing algorithm OID ' + oid + '"');
    }
  };

  this.publicKey = function () {
    switch (_this._algo) {
      case _constants.SIGNING_ALGO_RSA.name:
      case _constants.SIGNING_ALGO_ED25519.name:
        return new _publicKey2.default({
          publicKey: _this._key.publicKey(),
          algo: _this._algo
        });
      default:
        throw new Error('Unsupported signing algorithm "' + _this._algo + '"');
    }
  };

  this.sign = function (message) {
    // message should be a UInt8Array
    if (!(message instanceof Uint8Array)) throw new Error('unexpected type, use Uint8Array');

    var sig = void 0;
    switch (_this._algo) {
      case _constants.SIGNING_ALGO_RSA.name:
      case _constants.SIGNING_ALGO_ED25519.name:
        sig = _this._key.sign(message);
        break;
      default:
        throw new Error('Unsupported signing algorithm "' + _this._algo + '"');
    }

    return {
      public_key: (0, _utils.stringToBytes)(_this.publicKey().export()),
      signature: (0, _utils.stringToBytes)((0, _encoding.encodeSignature)(sig)),
      message: message
    };
  };

  this.export = function () {
    var password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var privateKeyInfo = void 0;
    switch (_this._algo) {
      case _constants.SIGNING_ALGO_RSA.name:
      case _constants.SIGNING_ALGO_ED25519.name:
        privateKeyInfo = _this._key.toPkcs8();
        break;
      default:
        throw new Error('Unsupported signing algorithm "' + _this._algo + '"');
    }

    if (!password) return (0, _encoding.encodePrivateKeyInfo)(privateKeyInfo, _this._algo);

    var encryptedPrivateKeyInfo = _nodeForge.pki.encryptPrivateKeyInfo(privateKeyInfo, password, { algorithm: 'aes256' });

    // Export keys to pem format
    return _nodeForge.pki.encryptedPrivateKeyToPem(encryptedPrivateKeyInfo);
  };
};

exports.default = SigningPrivateKey;